// Components
import { Box, Tooltip } from "@mui/material";
import FlatPriceText from "src/views/offer/Components/FlatPriceText";

// Hooks
import clsx from "clsx";
import type { FormikErrors } from "formik";
import { useScenarioCardStyles } from "src/views/marketing-actions/components/form/ScenarioCard/ScenarioCard.styles";

export function ScenarioDisplayLine({
    icon,
    text,
    error,
    subText,
    isPrice,
}: {
    icon?: any;
    text: string;
    error?: FormikErrors<any>;
    subText: string | number;
    isPrice: boolean;
}): JSX.Element {
    const classes = useScenarioCardStyles();
    return (
        <Box
            className={clsx({
                [classes.ScenarioDisplayLineContainer]: true,
                [classes.ScenarioError]: !!error,
            })}
        >
            {/* ICON */}
            <Box className={classes.ScenarioDisplayLineIconContainer}>{icon}</Box>

            {/* TEXT */}
            <Tooltip title={error?.products ? <>{error.products}</> : ""} placement="top">
                <Box className={classes.ScenarioDisplayLineTextContainer}>
                    <span className={classes.ScenarioDisplayLineText}>{text}</span>
                    {isPrice === true && subText !== "-" && (
                        <FlatPriceText
                            className={classes.boldAndSmallText}
                            amount={Number.parseFloat(subText?.toString())}
                        />
                    )}
                    {(isPrice !== true || subText === "-") && (
                        <span className={classes.boldAndSmallText}>{subText}</span>
                    )}
                </Box>
            </Tooltip>
        </Box>
    );
}
